import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmInfoLabelsComponent } from './arm-info-labels/arm-info-labels.component';
import { ArmInfoBoxComponent } from './arm-info-box/arm-info-box.component';
import { ArmInfoImageComponent } from './arm-info-image/arm-info-image.component';

@NgModule({
  declarations: [
    ArmInfoLabelsComponent,
    ArmInfoBoxComponent,
    ArmInfoImageComponent
  ],
  exports: [
    ArmInfoLabelsComponent,
    ArmInfoImageComponent
  ],
  imports: [
    CommonModule
  ]
})
export class InfoWrappersModule { }
